import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { CompanyAvatar } from "@components/common/company-avatar";
import { isSdbCompanySelectedSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { Fragment } from "react";
import { withEllipsis } from "@styles/common-styles";
import { Checkmark2Icon, Tooltip, Divider, MenuItem } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";
/**
 * Renders a simple sdbCompany inside the sdbCompanies menu.
 *
 * @returns sdbCompany item react component.
 */
export function SdbCompanyMenuItem(t0) {
  const $ = _c(37);
  const {
    sdbCompany,
    shouldShowDivider
  } = t0;
  let t1;
  if ($[0] !== sdbCompany.id) {
    t1 = isSdbCompanySelectedSelector(sdbCompany.id);
    $[0] = sdbCompany.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSdbCompanySelected = useAppSelector(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      paddingY: "4px",
      paddingX: "8px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isSdbCompanySelected ? "surfaces.tertiary" : "none";
  const t4 = isSdbCompanySelected ? "primary.main" : "text.primary";
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = {
      backgroundColor: t3,
      color: t4,
      borderRadius: "8px",
      paddingY: "4px",
      paddingX: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%"
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      display: "flex",
      alignItems: "center"
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = sdbCompany.type === "admin" ? PALETTE_VARS.common.black : PALETTE_VARS.primary.main;
  let t8;
  if ($[7] !== sdbCompany.name || $[8] !== t7) {
    t8 = <Box component="div"><CompanyAvatar name={sdbCompany.name} color={t7} size="small" /></Box>;
    $[7] = sdbCompany.name;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== sdbCompany.name) {
    t9 = <var>{sdbCompany.name}</var>;
    $[10] = sdbCompany.name;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      ...withEllipsis,
      marginTop: "2px",
      marginLeft: "7px",
      fontSize: "13px",
      maxWidth: "calc(100vw - 110px)"
    };
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== sdbCompany.name) {
    t11 = <Box component="div" sx={t10}><var>{sdbCompany.name}</var></Box>;
    $[13] = sdbCompany.name;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t9) {
    t12 = <Tooltip component="div" title={t9}>{t11}</Tooltip>;
    $[15] = t11;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t8) {
    t13 = <Box component="div" sx={t6}>{t8}{t12}</Box>;
    $[18] = t12;
    $[19] = t8;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== isSdbCompanySelected) {
    t14 = isSdbCompanySelected && <Box component="div" sx={{
      marginBottom: "-5px",
      marginLeft: "2px"
    }}><Checkmark2Icon sx={{
        width: "20px",
        height: "20px",
        fill: PALETTE_VARS.primary.main
      }} /></Box>;
    $[21] = isSdbCompanySelected;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t13 || $[24] !== t14 || $[25] !== t5) {
    t15 = <Box component="div" sx={t5}>{t13}{t14}</Box>;
    $[23] = t13;
    $[24] = t14;
    $[25] = t5;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== isSdbCompanySelected || $[28] !== sdbCompany.url || $[29] !== t15) {
    t16 = <MenuItem component="a" data-testid="SIDEBAR_WORKSPACE_ITEM" href={sdbCompany.url} sx={t2} disabled={isSdbCompanySelected}>{t15}</MenuItem>;
    $[27] = isSdbCompanySelected;
    $[28] = sdbCompany.url;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== shouldShowDivider) {
    t17 = shouldShowDivider && <Divider />;
    $[31] = shouldShowDivider;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== sdbCompany.id || $[34] !== t16 || $[35] !== t17) {
    t18 = <Fragment key={sdbCompany.id}>{t16}{t17}</Fragment>;
    $[33] = sdbCompany.id;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
}